module.exports = __webpack_public_path__ + "static/media/automjete.304d00c6.jpg";